import { BlockType } from '../terrain'

import grassIcon from '../static/block-icon/grass.png'
import stoneIcon from '../static/block-icon/stone.png'
import treeIcon from '../static/block-icon/tree.png'
import woodIcon from '../static/block-icon/wood.png'
import diamondIcon from '../static/block-icon/diamond.png'
import quartzIcon from '../static/block-icon/quartz.png'
import glassIcon from '../static/block-icon/glass.png'
import sandIcon from '../static/textures/block/sand.png'
import sandstoneIcon from '../static/textures/block/sandstone.png'
import cactusIcon from '../static/textures/block/cactus_side.png'
import jungleTreeIcon from '../static/textures/block/jungle_log.png'
import jungleWoodIcon from '../static/textures/block/jungle_planks.png'
import coalIcon from '../static/textures/item/coal.png'
import stickIcon from '../static/textures/item/stick.png'
import ironPickaxeIcon from '../static/textures/item/iron_pickaxe.png'
import ironSwordIcon from '../static/textures/item/iron_sword.png'
import beefIcon from '../static/textures/item/beef.png'
import rottenFleshIcon from '../static/textures/item/rotten_flesh.png'
import ironOreIcon from '../static/textures/block/iron_ore.png'
import diamondOreIcon from '../static/textures/block/diamond_ore.png'
import furnaceIcon from '../static/textures/block/furnace_front.png'
import ironIngotIcon from '../static/textures/item/iron_ingot.png'
import cookedBeefIcon from '../static/textures/item/cooked_beef.png'
import cookedMuttonIcon from '../static/textures/item/cooked_mutton.png'
import waterIcon from '../static/textures/block/water.png'
import chestIcon from '../static/textures/block/jukebox_side.png'

export type ItemId =
  | 'grass'
  | 'stone'
  | 'sand'
  | 'sandstone'
  | 'cactus'
  | 'tree'
  | 'jungleTree'
  | 'wood'
  | 'jungleWood'
  | 'coal'
  | 'diamond'
  | 'quartz'
  | 'glass'
  | 'stick'
  | 'ironPickaxe'
  | 'ironSword'
  | 'beef'
  | 'rottenFlesh'
  | 'water'
  | 'ironOre'
  | 'diamondOre'
  | 'furnace'
  | 'ironIngot'
  | 'cookedBeef'
  | 'cookedMeat'
  | 'chest'

export type InventorySlot = {
  itemId: ItemId
  count: number
} | null

type ItemDefinition = {
  id: ItemId
  name: string
  icon: string
  blockType?: BlockType
}

export const ITEMS: Record<ItemId, ItemDefinition> = {
  grass: {
    id: 'grass',
    name: '草方块',
    icon: grassIcon,
    blockType: BlockType.grass
  },
  stone: {
    id: 'stone',
    name: '石头',
    icon: stoneIcon,
    blockType: BlockType.stone
  },
  sand: {
    id: 'sand',
    name: '沙子',
    icon: sandIcon,
    blockType: BlockType.sand
  },
  sandstone: {
    id: 'sandstone',
    name: '砂岩',
    icon: sandstoneIcon,
    blockType: BlockType.sandstone
  },
  cactus: {
    id: 'cactus',
    name: '仙人掌',
    icon: cactusIcon,
    blockType: BlockType.cactus
  },
  tree: {
    id: 'tree',
    name: '橡木原木',
    icon: treeIcon,
    blockType: BlockType.tree
  },
  jungleTree: {
    id: 'jungleTree',
    name: '丛林原木',
    icon: jungleTreeIcon,
    blockType: BlockType.jungleTree
  },
  wood: {
    id: 'wood',
    name: '橡木木板',
    icon: woodIcon,
    blockType: BlockType.wood
  },
  jungleWood: {
    id: 'jungleWood',
    name: '丛林木板',
    icon: jungleWoodIcon,
    blockType: BlockType.jungleWood
  },
  coal: {
    id: 'coal',
    name: '煤炭',
    icon: coalIcon,
    blockType: BlockType.coal
  },
  diamond: {
    id: 'diamond',
    name: '钻石块',
    icon: diamondIcon,
    blockType: BlockType.diamond
  },
  quartz: {
    id: 'quartz',
    name: '石英块',
    icon: quartzIcon,
    blockType: BlockType.quartz
  },
  glass: {
    id: 'glass',
    name: '玻璃',
    icon: glassIcon,
    blockType: BlockType.glass
  },
  stick: {
    id: 'stick',
    name: '木棍',
    icon: stickIcon
  },
  ironPickaxe: {
    id: 'ironPickaxe',
    name: '铁镐',
    icon: ironPickaxeIcon
  },
  ironSword: {
    id: 'ironSword',
    name: '铁剑',
    icon: ironSwordIcon
  },
  beef: {
    id: 'beef',
    name: '生牛肉',
    icon: beefIcon
  },
  rottenFlesh: {
    id: 'rottenFlesh',
    name: '腐肉',
    icon: rottenFleshIcon
  },
  water: {
    id: 'water',
    name: '水',
    icon: waterIcon,
    blockType: BlockType.water
  },
  ironOre: {
    id: 'ironOre',
    name: '铁矿石',
    icon: ironOreIcon,
    blockType: BlockType.ironOre
  },
  diamondOre: {
    id: 'diamondOre',
    name: '钻石矿石',
    icon: diamondOreIcon,
    blockType: BlockType.diamondOre
  },
  furnace: {
    id: 'furnace',
    name: '熔炉',
    icon: furnaceIcon,
    blockType: BlockType.furnace
  },
  ironIngot: {
    id: 'ironIngot',
    name: '铁锭',
    icon: ironIngotIcon
  },
  cookedBeef: {
    id: 'cookedBeef',
    name: '熟牛肉',
    icon: cookedBeefIcon
  },
  cookedMeat: {
    id: 'cookedMeat',
    name: '熟肉',
    icon: cookedMuttonIcon
  },
  chest: {
    id: 'chest',
    name: '箱子',
    icon: chestIcon,
    blockType: BlockType.chest
  }
}

export const HOTBAR_ITEMS: ItemId[] = [
  'grass',
  'stone',
  'sand',
  'tree',
  'wood',
  'jungleTree',
  'jungleWood',
  'ironPickaxe',
  'ironSword'
]

const blockItemMap = new Map<BlockType, ItemId>()

for (const item of Object.values(ITEMS)) {
  if (item.blockType !== undefined) {
    blockItemMap.set(item.blockType, item.id)
  }
}

export const getItemByBlockType = (blockType: BlockType) => {
  const itemId = blockItemMap.get(blockType)
  return itemId ? ITEMS[itemId] : null
}

export const getBlockTypeByItemId = (itemId: ItemId) => {
  return ITEMS[itemId].blockType
}
